import moment from 'moment';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { IconButton, Tooltip } from '@mui/material';

/**
 * DateFormat row control — shows current value as preview + edit button → dialog.
 * Tooltip shows today's date formatted with the current format string.
 * @param {object} props
 * @param {string} props.value - Current format string
 * @param {function} props.onEdit - Opens the DateFormatDialog
 */
const tooltipSx = {
    bgcolor: '#0b1e2e',
    color: '#a3d1ff',
    border: '0.5px solid #294766',
    fontSize: '12px',
    borderRadius: '3px',
    fontFamily: "'DM Sans', sans-serif",
};

export default function SettingsDateFormat({ value, onEdit }) {
    const preview = value ? moment().format(value) : '—';

    return (
        <>
            <Tooltip
                title={
                    <span>
                        Example date format: <span style={{ color: '#4cceac', fontWeight: 600 }}>{preview}</span>
                    </span>
                }
                placement="top"
                componentsProps={{ tooltip: { sx: tooltipSx } }}
            >
                <span className="settings-preview" style={{ cursor: 'default' }}>{value || '—'}</span>
            </Tooltip>
            <IconButton size="small" onClick={onEdit} sx={{ color: '#294766', '&:hover': { color: '#66b2ff' } }}>
                <EditOutlinedIcon sx={{ fontSize: 14 }} />
            </IconButton>
        </>
    );
}
